import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Phone, ArrowRight, CheckCircle } from "lucide-react";
import { trackClickToCall } from "@/utils/analytics";

export function InlineEstimateForm() {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" data-testid="inline-estimate">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{color: 'white'}}>
              Get Your Free Estimate
            </h2>
            <p className="text-lg mb-8" style={{color: '#94a3b8'}}>
              Tell us about your project and we'll provide a detailed estimate — usually within 30 minutes. No obligation, no pressure.
            </p>
            <div className="space-y-4">
              {[
                "Free, no-obligation estimates",
                "Most answered within 30 minutes",
                "Transparent pricing — no hidden fees",
                "Available 6 days a week"
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-green-400 shrink-0" />
                  <span style={{color: '#cbd5e1'}}>{item}</span>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <a href="tel:+19492040301" onClick={trackClickToCall} className="inline-flex items-center gap-2 text-orange-400 hover:text-orange-300 font-semibold text-lg transition-colors">
                <Phone className="w-5 h-5" />
                Or call (949) 204-0301
              </a>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Request an Estimate</h3>
            <div className="space-y-4">
              <Button
                className="w-full bg-orange-600 hover:bg-orange-700 text-white text-lg py-6 rounded-xl"
                onClick={() => navigate("/get-estimate")}
              >
                Start Your Free Estimate <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <p className="text-center text-gray-400 text-sm">Takes less than 2 minutes</p>
              <div className="flex items-center gap-4 pt-2">
                <div className="flex-1 border-t border-gray-200"></div>
                <span className="text-gray-400 text-sm">or try our instant calculators</span>
                <div className="flex-1 border-t border-gray-200"></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <Button variant="outline" className="text-sm" onClick={() => navigate("/tv-mounting")}>
                  TV Mounting
                </Button>
                <Button variant="outline" className="text-sm" onClick={() => navigate("/window-cleaning")}>
                  Window Cleaning
                </Button>
                <Button variant="outline" className="text-sm" onClick={() => navigate("/pressure-washing")}>
                  Pressure Washing
                </Button>
                <Button variant="outline" className="text-sm" onClick={() => navigate("/maintenance-membership")}>
                  Maintenance Plan
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
